export default function IdleWarningModal({ secondsLeft, onStay, onSignOut }) {
  const mins    = Math.floor(secondsLeft / 60)
  const secs    = secondsLeft % 60
  const timeStr = mins > 0
    ? `${mins}:${String(secs).padStart(2, '0')}`
    : `${secondsLeft}s`

  return (
    <div className="fixed inset-0 bg-black/50 z-[9999] flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-sm w-full p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
            <svg className="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900">Still there?</h3>
            <p className="text-sm text-gray-500">You've been inactive for a while.</p>
          </div>
        </div>
        <p className="text-sm text-gray-600 mb-5">
          You'll be automatically signed out in{' '}
          <span className="font-bold text-amber-600 tabular-nums">{timeStr}</span>.
        </p>
        <div className="flex gap-3">
          <button
            onClick={onStay}
            className="flex-1 bg-brand-red hover:bg-brand-red-dark text-white text-sm font-medium py-2 px-4 rounded-lg transition-colors"
          >
            Stay Logged In
          </button>
          <button
            onClick={onSignOut}
            className="text-sm text-gray-500 hover:text-gray-700 py-2 px-4 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors"
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  )
}
